import { useGetPresentersList } from '@/hooks';
import { PolotnoStoreActivePageKeys, usePolotnoActivePageState } from '@/pages/AdvancedEditor/hooks';
import { ImageType, PresenterUsecase } from '@d-id/types';

export const useGetCurrentPresenter = (presenterType?: ImageType) => {
    const usecase = PresenterUsecase.Video;
    const [selectedPresenter] = usePolotnoActivePageState(PolotnoStoreActivePageKeys.selectedPresenter);
    const [selectedPresenterType] = usePolotnoActivePageState(PolotnoStoreActivePageKeys.selectedPresenterType);

    const { data: presenters } = useGetPresentersList({ usecase, presenterType: presenterType || selectedPresenterType });

    if (presenters) {
        return presenters.find(presenter => presenter.id === selectedPresenter);
    }
};
